import React, { useEffect, useState } from 'react';
import SideBar from '../components/SideBar';
import DetailsHeaderBar from '../components/DetailsHeaderBar';
import DetailsTopBar from '../components/DetailsTopBar';
import { useLocation, useNavigate } from 'react-router-dom';
import HistoryTable from '../components/HistoryTable';
import { businessAgentAPI } from '../services/businessAgentService';

function BusinessAgentInvitationHistory() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  const [invitations, setInvitations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (agent?.agent_id) {
      fetchReferralHistory();
    }
  }, [agent, currentPage]);

  const fetchReferralHistory = async () => {
    if (!agent?.agent_id) {
      setError('No agent ID available');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const filters = {
        page: currentPage,
        per_page: 10
      };

      const response = await businessAgentAPI.getAgentReferralHistory(agent.agent_id, filters);
      console.log('Using Agent ID:', agent.agent_id);
      if (response.referrals) {
        setInvitations(response.referrals);
      }
    } catch (err) {
      setError('Failed to fetch referral history');
      console.error('Error fetching referral history:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!agent) {
    return <p style={{ padding: "30px" }}>No agent data available.</p>;
  }

  // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/business-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/business-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/business-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Request Details",
      path: "/business-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true;
      return tab.showWhen === agentStatus;
    });
  };

  const tabs = getTabsByStatus(agent.status);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  // Prepare data for the table - using the same structure as before
  const tableData = invitations.map(invitation => ({
    name: invitation.name || `${invitation.first_name || ''} ${invitation.last_name || ''}`.trim(),
    email: invitation.email || 'N/A',
    joinedDate: formatDate(invitation.joined_date),
    status: invitation.status || 'pending'
  }));

  // Table column configuration - same as before
  const columns = [
    { label: "Name", field: "name" },
    { label: "Email", field: "email" },
    { label: "Joined Date", field: "joinedDate" },
    { label: "Status", field: "status" }
  ];

  const goToEdit = () => {
    navigate("/edit-agent-profile", { state: { agent } });
  };

  console.log('Using Agent ID:', agent.agent_id);

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Business Agent Details"
          subtitle="You can edit you details to upadate your profile"
          breadcrumbs={[
            { label: "Home", path: "/dashboard" },
            { label: "Manage Business Agent", path: "/manage-business-agent" },
            { label: "Business Agent Details" }
          ]}
        />
        
        <DetailsTopBar
          tabs={tabs}
          activeTab="invitation"
          agent={agent}
        />

        {/* Error Message */}
        {error && (
          <div style={{ 
            background: '#f8d7da', 
            color: '#721c24', 
            padding: '10px', 
            borderRadius: '4px', 
            marginBottom: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            {error}
            <button 
              onClick={fetchReferralHistory} 
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Retry
            </button>
          </div>
        )}

        <HistoryTable
          columns={columns}
          data={tableData}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          rowsPerPage={10}
        />
      </div>
    </div>
  );
}

export default BusinessAgentInvitationHistory;